<template>
    <b-modal v-model="ShowModal" id="modal-center" class="modal-validation" size="md" no-close-on-backdrop='true'
        no-close-on-esc='true' title="Please update your details" centered hide-footer
        @close="handleClose">
        <template v-slot:default="">
            <p>{{DisplayMessage}}</p>
            <br />            
            <div class="modal-button-wrapper">
                <b-button block variant="danger" @click="handleOk">OK</b-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
    import CommonService from "../services/common";
    export default {
        name: "ValidationDialog",
        props: ["ShowModal", "DisplayMessage",  "RouteUrl"],

        data() {
            return {
            };
        },
        methods: {
            handleOk: function (evt) {

                this.$router.push(this.RouteUrl);                
                this.ShowModal = false;
                evt.preventDefault();
            },
            handleClose: function(evt){
                debugger;
                this.ShowModal = false;
                this.$emit('closeclicked', this.ShowModal);
                evt.preventDefault();
            }
        }
    };
</script>
<style scoped>
</style>